(function () {
  if (window.customElements && window.customElements.get('custom-variant-selector')) {
    return;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    var format = (window.theme && theme.moneyFormat) || '€{{amount}}';
    var formatted = (cents / 100).toFixed(2).replace('.', ',');
    return format.replace('{{amount}}', formatted).replace('{{ amount }}', formatted);
  }

  function toCents(value) {
    if (value === null || value === undefined || value === '') return null;
    var n = parseInt(String(value).replace(/[^0-9]/g, ''), 10);
    if (isNaN(n)) return null;
    return n;
  }

  function getCartAddUrl() {
    if (window.theme && theme.routes && theme.routes.cart_add_url) {
      return theme.routes.cart_add_url;
    }
    return (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js';
  }

  class CustomVariantSelector extends HTMLElement {
    constructor() {
      super();
      this.handleQuantityChange = this.handleQuantityChange.bind(this);
      this.handleAddToCart = this.handleAddToCart.bind(this);
      this.handleDocClick = this.handleDocClick.bind(this);
      this.handleKey = this.handleKey.bind(this);
    }

    connectedCallback() {
      this.initialPrice = parseInt(this.getAttribute('data-original-price'), 10) || 0;
      this.twoBoxesPrice = toCents(this.getAttribute('data-two-boxes-final-price'));
      this.threeBoxesPrice = toCents(this.getAttribute('data-three-boxes-final-price'));

      this.quantityInputs = this.querySelectorAll('input[type="radio"][name^="cvs_quantity_"]');
      this.variantBlocks = this.querySelectorAll('[data-variant-block]');
      this.dropdowns = this.querySelectorAll('[data-cvs-dropdown]');
      this.priceEl = this.querySelector('[data-cvs-price]');
      this.atcButton = this.querySelector('[data-cvs-atc]');

      this.quantityInputs.forEach((input) => {
        input.addEventListener('change', this.handleQuantityChange);
      });

      this.dropdowns.forEach((dd) => this.bindDropdown(dd));

      if (this.atcButton) {
        this.atcButton.addEventListener('click', this.handleAddToCart);
      }

      document.addEventListener('click', this.handleDocClick);
      document.addEventListener('keydown', this.handleKey);

      const initialQty = this.getCurrentQuantity();
      this.updateVariantBlocks(initialQty);
      this.updatePrice(initialQty);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleDocClick);
      document.removeEventListener('keydown', this.handleKey);
    }

    bindDropdown(dd) {
      const toggle = dd.querySelector('[data-cvs-toggle]');
      const list = dd.querySelector('[data-cvs-list]');
      const hidden = dd.querySelector('[data-cvs-value]');
      const text = dd.querySelector('[data-cvs-text]');
      const swatch = dd.querySelector('.cvs__dropdown-toggle .cvs__swatch');
      const items = dd.querySelectorAll('[data-cvs-option]');

      if (!toggle || !list || !hidden) return;

      toggle.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = dd.classList.contains('is-open');
        this.closeAllDropdowns();
        if (!isOpen) {
          dd.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });

      items.forEach((item) => {
        item.addEventListener('click', (e) => {
          e.stopPropagation();
          if (item.dataset.unavailable === 'true') return;

          const variantId = item.getAttribute('data-variant-id');
          const flavor = item.getAttribute('data-flavor');
          const swatchKey = item.getAttribute('data-swatch-key');

          hidden.value = variantId;
          if (text) text.textContent = flavor;
          if (swatch) swatch.setAttribute('data-swatch', swatchKey);

          items.forEach((li) => {
            li.classList.toggle('is-selected', li === item);
            li.setAttribute('aria-selected', li === item ? 'true' : 'false');
          });

          dd.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');

          // Für Seiten, auf denen der native Variantenwähler parallel existiert
          // (z. B. Riegel): Auswahl melden, damit Galerie & Co. mitziehen.
          this.dispatchEvent(new CustomEvent('cvs:variant-change', {
            bubbles: true,
            detail: { box: dd.getAttribute('data-box'), variantId: variantId, flavor: flavor }
          }));
        });
      });
    }

    closeAllDropdowns() {
      this.dropdowns.forEach((dd) => {
        dd.classList.remove('is-open');
        const t = dd.querySelector('[data-cvs-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }

    handleDocClick(e) {
      if (!this.contains(e.target)) {
        this.closeAllDropdowns();
      }
    }

    handleKey(e) {
      if (e.key === 'Escape') this.closeAllDropdowns();
    }

    getCurrentQuantity() {
      const checked = this.querySelector('input[type="radio"][name^="cvs_quantity_"]:checked');
      return checked ? parseInt(checked.value, 10) : 1;
    }

    handleQuantityChange(event) {
      const qty = parseInt(event.target.value, 10);
      this.updateVariantBlocks(qty);
      this.updatePrice(qty);
    }

    updateVariantBlocks(qty) {
      this.variantBlocks.forEach((block) => {
        const n = parseInt(block.getAttribute('data-variant-block'), 10);
        block.style.display = n <= qty ? '' : 'none';
      });
    }

    priceForQuantity(qty) {
      switch (qty) {
        case 2:
          return this.twoBoxesPrice && this.twoBoxesPrice > 0 ? this.twoBoxesPrice : this.initialPrice * 2;
        case 3:
          return this.threeBoxesPrice && this.threeBoxesPrice > 0 ? this.threeBoxesPrice : this.initialPrice * 3;
        default:
          return this.initialPrice;
      }
    }

    updatePrice(qty) {
      if (!this.priceEl) return;
      const total = this.priceForQuantity(qty);
      this.priceEl.textContent = formatMoney(total);
    }

    collectItems() {
      const qty = this.getCurrentQuantity();
      const counts = {};
      for (let i = 1; i <= qty; i++) {
        const dd = this.querySelector(`[data-cvs-dropdown][data-box="${i}"]`);
        const hidden = dd ? dd.querySelector('[data-cvs-value]') : null;
        if (!hidden || !hidden.value) {
          return { error: ((window.orgainicStrings && window.orgainicStrings.chooseFlavor) || 'Bitte für Box %i% einen Geschmack wählen.').replace('%i%', i) };
        }
        counts[hidden.value] = (counts[hidden.value] || 0) + 1;
      }
      const items = Object.keys(counts).map((id) => ({ id: parseInt(id, 10), quantity: counts[id] }));
      return { items };
    }

    async handleAddToCart(event) {
      event.preventDefault();
      if (!this.atcButton) return;

      const { items, error } = this.collectItems();
      if (error) { alert(error); return; }

      this.atcButton.classList.add('is-loading');
      this.atcButton.setAttribute('disabled', 'true');

      try {
        const response = await fetch(getCartAddUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          let message = (window.orgainicStrings && window.orgainicStrings.addError) || 'Fehler beim Hinzufügen zum Warenkorb.';
          try {
            const data = await response.json();
            if (data && data.description) message = data.description;
          } catch (e) { /* ignore */ }
          throw new Error(message);
        }

        // Theme drawer: refresh cart sections and open the drawer. (Historically
        // suppressed because the Opus app hooked /cart/add.js globally — Opus is
        // gone, so without this dispatch nothing updates or opens the drawer.)
        document.documentElement.dispatchEvent(
          new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: { openDrawer: true } })
        );
      } catch (err) {
        console.error('[custom-variant-selector] add-to-cart failed:', err);
        alert(err.message || (window.orgainicStrings && window.orgainicStrings.addError) || 'Fehler beim Hinzufügen zum Warenkorb.');
      } finally {
        this.atcButton.classList.remove('is-loading');
        this.atcButton.removeAttribute('disabled');
      }
    }
  }

  customElements.define('custom-variant-selector', CustomVariantSelector);
})();
